import React, { Component, FunctionComponent, RefObject } from 'react';

import * as Modal from '@yandex-360/orb-components/dist/components/Modal2';
import cn from 'classnames';

import { DEFAULT_MODAL_Z_INDEX } from '../../constants';
import css from './index.css';

interface ModalWithHeaderProps {
    title: string;
    className?: string;
    parentRef?: RefObject<Component | HTMLElement | null>;
    visible: boolean;
    onClose(): void;
    scrollable?: boolean;
    keepMounted?: boolean;
}

const ModalWithHeader: FunctionComponent<ModalWithHeaderProps> = ({
    className,
    children,
    title,
    visible,
    onClose,
    keepMounted = true,
}) => {
    return (
        <Modal.Modal
            className={cn(css.modal, className)}
            keepMounted={keepMounted}
            onClose={onClose}
            visible={visible}
            size="lg"
            zIndex={DEFAULT_MODAL_Z_INDEX}
        >
            <Modal.NavigationBar closable title={title} />
            <Modal.Slot>
                <div className={className}>
                    <div className={cn(css.contentContainer)}>{children}</div>
                </div>
            </Modal.Slot>
        </Modal.Modal>
    );
};

export default ModalWithHeader;
